import NotificationsFetch from "./NotificationsFetch"

export default NotificationsFetch
